// extracted by mini-css-extract-plugin
module.exports = {"root":"OUfpDg","bodyWrapper":"a7lBW9","body":"c3ZB2fg","footer":"mwJN0A"};